export default __webpack_public_path__ + "static/media/Asset 12.ab156adf.png";